export const aboutData = {
  brandStory: `蜜桃网站创立于2020年，是国内领先的精选内容聚合平台。我们致力于为用户提供高质量、多元化的内容体验，涵盖科技数码、娱乐影视、生活方式、美食旅行、健康养生、财经商业等多个领域。

我们的团队由一群热爱内容创作的资深编辑和技术专家组成，分布在北上广深等城市。每一天，我们的编辑团队都会从海量信息中筛选出最有价值的内容，为读者节约时间，提升阅读体验。

"内容为王，品质为先"是我们始终坚持的核心理念。在信息过载的时代，蜜桃网站希望成为每一位用户可信赖的内容伙伴，帮助大家高效获取知识、开拓视野、发现生活的美好。`,
  values: [
    {
      title: '品质优先',
      description: '每一篇内容都经过严格的编辑审核流程，确保信息的准确性、深度和可读性。我们不追求数量，只追求质量。',
      icon: 'ri-star-line',
    },
    {
      title: '用户至上',
      description: '我们始终以用户需求为导向，不断优化产品体验。从内容推荐算法到阅读界面设计，每个细节都为用户考虑。',
      icon: 'ri-user-heart-line',
    },
    {
      title: '创新驱动',
      description: '持续探索内容领域的新技术、新模式，运用AI技术提升内容分发效率和个性化推荐体验。',
      icon: 'ri-lightbulb-line',
    },
    {
      title: '社会责任',
      description: '作为内容平台，我们深知信息传播的社会责任。坚持传播正能量、有价值的内容，拒绝低质、虚假信息。',
      icon: 'ri-shield-check-line',
    },
  ],
  testimonials: [
    {
      name: '张先生',
      role: '互联网从业者',
      content: '蜜桃网站已经成为我每天的必读平台。内容质量很高，分类清晰，推荐算法也很精准，总能找到我感兴趣的内容。每天早上通勤路上刷一刷，收获满满。',
      avatar: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20male%20portrait%2C%20warm%20natural%20lighting%2C%20simple%20clean%20background%2C%20friendly%20expression&width=100&height=100&seq=avatar-01&orientation=squarish',
    },
    {
      name: '李女士',
      role: '自由撰稿人',
      content: '作为一个内容创作者，蜜桃网站给了我很多灵感。平台上的文章不仅质量好，而且涉猎范围很广。我经常把这里的文章推荐给我的读者朋友。',
      avatar: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20female%20portrait%2C%20warm%20natural%20lighting%2C%20simple%20clean%20background%2C%20confident%20expression&width=100&height=100&seq=avatar-02&orientation=squarish',
    },
    {
      name: '王同学',
      role: '大学生',
      content: '最喜欢的还是蜜桃网站的界面设计，干净简洁，没有各种弹窗广告，阅读体验特别好。分类也很全，学习累了就刷一刷生活类和美食类的内容，特别解压。',
      avatar: 'https://readdy.ai/api/search-image?query=Young%20Chinese%20student%20portrait%2C%20warm%20natural%20lighting%2C%20simple%20clean%20background%2C%20cheerful%20smile&width=100&height=100&seq=avatar-03&orientation=squarish',
    },
  ],
  contactInfo: {
    address: '北京市朝阳区望京SOHO T3-A座 2208室',
    phone: '400-888-6666',
    email: 'contact@weifutongmicropay.cn',
    workingHours: '周一至周五 9:00 - 18:00',
  },
  stats: [
    { label: '日均访问量', value: '580万+' },
    { label: '注册用户', value: '1200万+' },
    { label: '优质文章', value: '50万+' },
    { label: '合作作者', value: '3000+' },
  ],
};